import React, { useMemo } from "react";
import { baseUrlImg } from "../../config/api";

function formatDate(dateString) {
  if (!dateString) return "-";

  return new Date(dateString).toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const SystemProductsTicket = ({ arr }) => {
  const parsed = useMemo(() => {
    try {
      const receipt = JSON.parse(arr.receipt);
      return JSON.parse(receipt.data || "{}");
    } catch {
      return {};
    }
  }, [arr.receipt]);

  return (
    <div
      style={{
        fontFamily: "monospace",
        fontSize: 14,
        lineHeight: 1.6,
        maxWidth: 420,
        backgroundColor: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: 12,
        }}
      >
        <img
          src={`${baseUrlImg}/${arr.logo}`}
          alt="logo"
          style={{
            height: 50,
            maxWidth: 230,
            objectFit: "contain",
          }}
        />
      </div>

      <div style={rowStyle}>
        <span>Data:</span>
        <span>{formatDate(arr.created_at)}</span>
      </div>

      <div style={rowStyle}>
        <span>Prodotto:</span>
        <span>{parsed.sku || "-"}</span>
      </div>

      <div style={rowStyle}>
        <span>Importo:</span>
        <span>{parsed.price || "-"} €</span>
      </div>

      {!!parsed.attributes_json &&
        Object.keys(parsed.attributes_json).length > 0 && (
          <div
            style={{
              marginTop: 12,
              border: "1px dashed black",
              borderRadius: 6,
              padding: 10,
              backgroundColor: "#f9fafb",
            }}
          >
            <div
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: 13,
                marginBottom: 8,
                paddingBottom: 6,
                borderBottom: "1px dashed #9ca3af",
                letterSpacing: 1,
              }}
            >
              • DETTAGLI PRODOTTO •
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 6,
              }}
            >
              {Object.entries(parsed.attributes_json).map(
                ([key, value]) => (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <span
                      style={{
                        textTransform: "uppercase",
                        color: "#6b7280",
                        letterSpacing: 0.5,
                      }}
                    >
                      {key}
                    </span>

                    <span
                      style={{
                        fontWeight: 600,
                        maxWidth: "60%",
                        textAlign: "right",
                        wordBreak: "break-word",
                      }}
                    >
                      {value}
                    </span>
                  </div>
                )
              )}
            </div>
          </div>
        )}
    </div>
  );
};

const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  padding: "6px 0",
  borderBottom: "1px dashed #6b7280",
};

export default SystemProductsTicket;